import React, { useEffect, useState } from "react";
import styles from "./Hero.module.css";

const exams = ["SDLE?", "SMLE?"];
export default function HeroExamPrompt() {
  const [index, setIndex] = useState(0);
  const [text, setText] = useState("");
  const [deleting, setDeleting] = useState(false);
  const [reducedMotion, setReducedMotion] = useState(false);
  useEffect(() => {
    if (!window.matchMedia) return;
    const preference = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setReducedMotion(preference.matches);
    update();
    preference.addEventListener("change", update);
    return () => preference.removeEventListener("change", update);
  }, []);
  useEffect(() => {
    if (reducedMotion) return;
    const word = exams[index];
    const timeout = window.setTimeout(() => {
      if (!deleting && text === word) setDeleting(true);
      else if (deleting && text === "") { setDeleting(false); setIndex(value => (value + 1) % exams.length); }
      else setText(deleting ? text.slice(0, -1) : word.slice(0, text.length + 1));
    }, !deleting && text === word ? 2500 : deleting ? 50 : 100);
    return () => window.clearTimeout(timeout);
  }, [index, text, deleting, reducedMotion]);
  return <p className={styles.examPrompt}>
    <span className={styles.screenReaderText}>Preparing for your SDLE or SMLE?</span>
    <span aria-hidden="true"><span>Preparing for your </span><span className={styles.typingText}>{reducedMotion ? "SDLE or SMLE?" : text}</span>{!reducedMotion && <span className={styles.typingCursor} />}</span>
  </p>;
}
